// Material Kit 2 React pages
import UploadPage from "pages/LandingPages/Upload";

export default function UploadImagePage() {
  return <UploadPage />;
}
